import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl, ListingImageSizes } from '@domain-group/fe-allhomes-library';
import Avatar from '@domain-group/fe-co-avatar';
import BedIcon from '@domain-group/fe-co-icon/lib/js/bed';
import BathIcon from '@domain-group/fe-co-icon/lib/js/bath';
import ParkingIcon from '@domain-group/fe-co-icon/lib/js/parking';
import ListingModel from '../../models/listing';
import * as styles from './overlay-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OverlayCard = _ref => {
  var listing = _ref.listing,
    size = _ref.size,
    title = _ref.title,
    onClick = _ref.onClick;
  var renderFeature = (SelectedIcon, featureTitle, featureValue) => {
    if (featureValue) {
      return ___EmotionJSX("span", {
        css: styles.feature
      }, ___EmotionJSX("span", {
        css: styles.featureText({
          size
        })
      }, featureValue), ___EmotionJSX(SelectedIcon, {
        title: featureTitle,
        size: "small"
      }));
    }
    return false;
  };
  var displayStreet = () => {
    if (listing.newDevelopment && listing.propertyName) {
      return "".concat(listing.propertyName, ",");
    }
    if (listing.address.street && listing.address.street.length > 0) {
      return "".concat(listing.address.street, ",");
    }
    return ___EmotionJSX(Fragment, null, "\xA0");
  };
  return ___EmotionJSX("div", {
    css: styles.listingCard({
      size
    })
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: getImageUrl(listing.image.highRes, ListingImageSizes.LARGE),
    alt: ""
  }), ___EmotionJSX("h3", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.infoSection
  }, ___EmotionJSX("div", {
    css: styles.listingInfo({
      size
    })
  }, ___EmotionJSX("span", {
    css: styles.price({
      size
    })
  }, listing.formattedPrice), ___EmotionJSX("a", {
    css: styles.addressContainer,
    href: listing.url,
    onClick: onClick
  }, ___EmotionJSX("span", {
    css: styles.addressLine1
  }, displayStreet(), " "), ___EmotionJSX("span", {
    css: styles.addressLine2({
      size
    })
  }, listing.address.suburb, " ", listing.address.state, ' ', listing.address.postcode)), ___EmotionJSX("div", {
    css: styles.featureGroup
  }, renderFeature(BedIcon, 'Bedrooms', listing.formattedBeds), renderFeature(BathIcon, 'Bathrooms', listing.formattedBaths), renderFeature(ParkingIcon, 'Parking', listing.formattedParking))), ___EmotionJSX("div", {
    css: styles.agentInfo
  }, ___EmotionJSX(Avatar, {
    css: styles.agentPhoto,
    imageUrl: listing.agent.agentPhoto,
    isBordered: true,
    colorScheme: "light"
  }), ___EmotionJSX("img", {
    src: listing.agent.agencyLogo,
    css: styles.agencyLogo,
    alt: ""
  }))));
};
OverlayCard.propTypes = {
  listing: PropTypes.shape(ListingModel).isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large'])
};
OverlayCard.defaultProps = {
  onClick: () => {},
  title: 'Property of the Week',
  size: 'large'
};
export default OverlayCard;